const tokenHelpers = {};

tokenHelpers.getToken = () => {
    let token = localStorage.getItem('token');
    if (token === 'undefined') return null;
    else return token;
}

tokenHelpers.getCompanyToken = () => {
    let token = localStorage.getItem('company_api_key');
    if (token === 'undefined') return null;
    else return token;
}

tokenHelpers.getLocationToken = () => {
    let token = localStorage.getItem('location_api_key');
    if (token === 'undefined') return null;
    else return token;
}

export default tokenHelpers;



/** WEBPACK FOOTER **
 ** ./src/helpers/token.js
 **/